function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "76px",
    height: "76px",
    viewBox: "0 0 76 76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 11.398438 0 L 64.601562 0 C 70.894531 0 76 5.105469 76 11.398438 L 76 64.601562 C 76 70.894531 70.894531 76 64.601562 76 L 11.398438 76 C 5.105469 76 0 70.894531 0 64.601562 L 0 11.398438 C 0 5.105469 5.105469 0 11.398438 0 Z M 11.398438 0 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(25.882353%,72.156863%,51.372549%)",
      fillOpacity: 1
    },
    d: "M 44.53125 20.78125 L 38 32.210938 L 31.46875 20.78125 L 9.5 20.78125 L 38 70.210938 L 66.5 20.78125 Z M 44.53125 20.78125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(20.784314%,28.627451%,36.862745%)",
      fillOpacity: 1
    },
    d: "M 44.53125 20.78125 L 38 32.210938 L 31.46875 20.78125 L 20.929688 20.78125 L 38 50.46875 L 55.070312 20.78125 Z M 44.53125 20.78125 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVue);
export default __webpack_public_path__ + "static/media/vue.2b73e10ae633e137316a7df7feea766b.svg";
export { ForwardRef as ReactComponent };